import { Image } from 'components/Image/Image';

export const enrolledUrl = '/plus';
export const scoreSimulatorUrl = '/scoreSimulator';
export const imageRight = (
  <Image imgClass="sesamePlus" style={{ width: '150px', height: '28px' }} />
);
